import { ConfigValue } from './ConfigValue'

export type ConfigKeys = keyof typeof defaultConfig
export type ConfigType = Record<ConfigKeys, any>
export type RemoteConfigType = Record<keyof ConfigType, ConfigValue>

export const defaultConfig = {
  test: 'true', // for testing purposes
  configAnnouncement: '{}',
  enableFlexibleReferenceNumber: 'false',
}

export function getConfigValues(config: ConfigType) {
  return Object.entries(config).reduce((acc: RemoteConfigType, current: [string, string]) => {
    const [configName, value] = current

    const configValue = new ConfigValue(value)

    return { ...acc, [configName]: configValue }
  }, {} as RemoteConfigType)
}

export const defaultConfigValues = getConfigValues(defaultConfig)
